export function fillForm(data) {
  return data?.data?.map((el, index) => ({
    id: el.id,
    index: index,
    order: el.order,
    title: el.pageTitle,
  }));
}
